import React, { memo } from 'react';
import { connect } from 'react-redux';
import { useMantineTheme } from '@mantine/core';
import {
  ModalBackgdDiv,
  ModalContentDiv,
  ModalDiv,
  ModalTitleDiv,
  modalDialogStyle,
} from './ModalDialogCSS';
import { CloseIcon, MaximizeIcon, MinimizeIcon } from '../../../constants/icon';

class ModalDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offsetX: 0,
      offsetY: 0,
      isMaximized: false,
    };

    this.handleClickBG = this.handleClickBG.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.toggleMaximize = this.toggleMaximize.bind(this);
  }

  handleClickBG(e) {
    e.stopPropagation();
    if (
      e.currentTarget &&
      e.currentTarget.id === `div_bg${this.props.id}` &&
      e.target.id === `div_bg${this.props.id}`
    ) {
      this.props.onClose();
    }
  }

  handleDrag(e) {
    if (this.state.isMaximized) return; // Prevent dragging when maximized
    if (e.target.getAttribute('data-uitype') == 'titleBarModal') {
      switch (e.type) {
        case 'dragstart':
          this.setState({ startDragX: e.clientX, startDragY: e.clientY });
          break;
        case 'dragend':
          this.setState({
            offsetX: e.clientX - this.state.startDragX + this.state.offsetX,
            offsetY: e.clientY - this.state.startDragY + this.state.offsetY,
          });
          break;
        case 'drag':
          break;
        default:
          break;
      }
    }
  }

  toggleMaximize() {
    this.setState((prevState) => ({
      isMaximized: !prevState.isMaximized,
    }));
  }

  render() {
    let {
      show,
      width,
      height,
      top,
      left,
      menuPosX,
      menuPosY,
      onMouseLeave,
      id,
      paddingTitle,
      modalContentStyle = {},
      allowMaximize = false,
    } = this.props;
    if (this.state.isMaximized) {
      width = '100%';
      height = '100%';
      top = 0;
      left = 0;
    } else {
      top = this.state.offsetY + menuPosY + top;
      left = this.state.offsetX + menuPosX + left;
    }
    return show ? (
      <ModalBackgdDiv id={`div_bg${id}`} onClick={this.handleClickBG}>
        <ModalDiv
          id="modal_div_1"
          width={width}
          height={height}
          top={top}
          left={left}
          onMouseLeave={onMouseLeave}
          backgroundColor={'var(--ds-bg-base)'}
          padding={this.props.modalPadding}
          isMaximized={this.state.isMaximized}
        >
          <div
            id="titleBar"
            data-uitype="titleBarModal"
            draggable={true}
            onDrag={this.handleDrag}
            onDragStart={this.handleDrag}
            onDragEnd={this.handleDrag}
            style={{
              ...modalDialogStyle.titleBarModal,
              backgroundColor: 'var(--ds-bg-base)',
            }}
          >
            <ModalTitleDiv
              $color={'var(--ds-text-title)'}
              $padding={paddingTitle}
            >
              {this.props.title}
            </ModalTitleDiv>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {allowMaximize && (
                <div
                  onClick={this.toggleMaximize}
                  style={{
                    ...modalDialogStyle.actionIcon,
                    marginRight: '8px',
                    cursor: 'pointer',
                  }}
                >
                  {this.state.isMaximized ? <MinimizeIcon /> : <MaximizeIcon />}
                </div>
              )}
              <div
                onClick={this.props.onClose}
                style={modalDialogStyle.closeIcon}
              >
                <CloseIcon />
              </div>
            </div>
          </div>
          <ModalContentDiv
            $padding={this.props.modalContentPadding}
            id="modalContent"
            $backgroundColor={'var(--ds-bg-base)'}
            style={modalContentStyle}
          >
            {this.props.children}
          </ModalContentDiv>
        </ModalDiv>
      </ModalBackgdDiv>
    ) : (
      <></>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    menuPosX: state.objects.menuPosX,
    menuPosY: state.objects.menuPosY,
  };
};
//--------------------------------------------------------------------------------------------------------
const mapDispatchToProps = (dispatch) => ({});

const ModalDialogHOC = (props) => {
  const theme = useMantineTheme();
  return <ModalDialog {...props} theme={theme} />;
};
export default memo(
  connect(mapStateToProps, mapDispatchToProps)(ModalDialogHOC)
);

//-------------------------------------------------------------------------------------------------------
ModalDialog.defaultProps = {
  width: '600px',
  height: '400px',
  top: '200px',
  left: '200px',
  id: '1',
  allowMaximize: false,
};
